import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CONTACT } from "@/data/products";
import { useProducts } from "@/context/ProductsContext";

export const Footer = () => {
  const { products: PRODUCTS } = useProducts();
  return (
  <footer data-testid="site-footer" className="bg-[#0B0B0B] text-zinc-300">
    <div className="mx-auto grid max-w-[1440px] gap-12 px-5 py-20 md:grid-cols-12 md:px-10">
      <div className="md:col-span-4">
        <Logo light />
        <p className="mt-6 max-w-xs text-sm leading-relaxed text-zinc-400">
          Tide Inchem Private Limited. Manufacturer and supplier of printing inks for the printing and packaging industries since 1997.
        </p>
      </div>
      <div className="md:col-span-5">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FFC400]">Catalogue</p>
        <ul className="mt-5 grid grid-cols-1 gap-2 sm:grid-cols-2">
          {PRODUCTS.map((p) => (
            <li key={p.slug}>
              <Link to={`/products/${p.slug}`} data-testid={`footer-product-${p.slug}`} className="text-sm text-zinc-300 transition-colors hover:text-[#FF5A00]">{p.short}</Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="md:col-span-3">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#FFC400]">Reach us</p>
        <a href={`tel:${CONTACT.tel}`} data-testid="footer-phone" className="mt-5 block text-white hover:text-[#FF5A00]">{CONTACT.phone}</a>
        <a href={`tel:${CONTACT.tel2}`} data-testid="footer-phone2" className="mt-2 block text-white hover:text-[#FF5A00]">{CONTACT.phone2}</a>
        <a href={`mailto:${CONTACT.email}`} data-testid="footer-email" className="mt-2 block text-white hover:text-[#FF5A00]">{CONTACT.email}</a>
        <p className="mt-4 text-sm text-zinc-400">{CONTACT.address}</p>
      </div>
    </div>
    <div className="overflow-hidden border-t border-white/10">
      <p className="font-wide select-none whitespace-nowrap px-5 py-6 text-[14vw] font-black uppercase leading-[0.8] tracking-tighter text-white/[0.06] md:px-10">Tide Inchem</p>
    </div>
    <div className="mx-auto flex max-w-[1440px] flex-col justify-between gap-2 px-5 pb-8 font-mono text-xs text-zinc-400 sm:flex-row md:px-10">
      <span>© {new Date().getFullYear()} Tide Inchem Pvt. Ltd.</span>
      <span>Dada Nagar · Kanpur · India</span>
    </div>
  </footer>
  );
};
